import { APP_NAME } from "./config/env.config";

// ---------------- BASE URLS ----------------
const BASE_URL = process.env.REACT_APP_API_BaseUrl;
const FILE_BASE_URL = process.env.REACT_APP_FILEUPLOAD;
const EMAIL_BASE_URL = process.env.REACT_APP_EMAIL_RATING;
const UPLOAD_BASE_URL = process.env.REACT_APP_API_FileUrl;
const PROCURE_EMAIL = process.env.REACT_APP_API_procure_email;

export const LOGO_BASE_URL = process.env.REACT_APP_API_LogoBaseUrl;
const RPT_BASE_URL = "https://api-rpt.lorri.in";
const LOCAL_BASE_URL = "http://localhost:8001";

// ---------------- API PREFIXES ----------------
const API = {
  LORRI: `${BASE_URL}/api/apilorri`,
  USER: `${BASE_URL}/api/apiuser`,
  SPOT: `${BASE_URL}/api/spot`,
  INDENT: `${BASE_URL}/api/indent`,
  AUCTION: `${BASE_URL}/api`,
  FILE: `${FILE_BASE_URL}/api`,
  PLANNING: `${BASE_URL}/api/planning`,
  RPT: `${RPT_BASE_URL}/api`,
};

// ---------------- URLS ----------------
export const Urls = {
  Autocomplete: `${API.USER}/autocomplete`,
  BusinessEnquiries: process.env.REACT_APP_API_BusinessEnquiries,
  Streaming_data: {
    Get: `${API.USER}/streaming_data`,
    Post: `${API.USER}/streaming_data`,
  },
  Network_data: {
    Get: `${API.USER}/network_data`,
  },
  Transporter: {
    Get: `${API.USER}/my-profile`,
    Post: `${API.USER}/transporter`,
    Details: `${API.USER}/transporter_details`,
    Settings: `${API.LORRI}/settings`,
    updateAttachments: `${API.AUCTION}/update_attachments`,
  },
  Company: {
    Get: `${API.USER}/autocomplete?searchFields=company&suggest={0}&limit=5`,
    GetAll: `${API.USER}/autocomplete?searchFields=company`,
    CompanyData: `${API.LORRI}/company_data`,
  },
  Locations: {
    Get: `${API.USER}/autocomplete?searchFields=new_locations&suggest={0}&limit=10`,
    autoSuggest: `${API.USER}/autocomplete`,
  },
  Spot_data: {
    Get: `${API.SPOT}/tpmp_spot_v2`,
    Post: `${API.SPOT}/tpmp_spot_v2`,
  },
  filters: `${API.SPOT}/filters`,
  email_template: `${API.SPOT}/editble_emails`,
  TruckEnquiryChat: `${API.SPOT}/truck_enquiry_chat?code=XaESaF5xua0WkDWuSl9OZfVowjmjl6KLcMMJv0sCWPfL1SgM4RBUfA==`,
  indent: `${API.INDENT}/indent_tpmp`,
  invoice: `${API.INDENT}/invoice_tpmp`,
  indent_chat: `${API.INDENT}/indent_chat?code=CpidrqVD4RMunlYuFdRI4ymhQE5qr/za85HbgawlVtXPvBDjvQb06Q==`,
  auction: `${API.AUCTION}/tpmpauction`,
  auctionBase: `${API.AUCTION}/`,
  messages: `${API.AUCTION}`,
  expressiveQuotations: `${API.AUCTION}/ratecard?`,
  worldAPI: `${API.AUCTION}/current_timestamp`,
  Duplicate: `${API.LORRI}/duplicates`,
  RateCard: `${API.LORRI}/rate-card`,
  rate: `${API.LORRI}/rate-card`,
  log: `${API.LORRI}/log`,
  LocationAnalysis: `${API.LORRI}/tpmp-location-analysis`,
  companyProfile: `${API.LORRI}/company-profile`,
  settings: `${API.LORRI}/settings`,
  dashboard: `${BASE_URL}`,
  lorriFileService: `${API.FILE}/fileupload`,
  lorriFileServiceNew: `${API.LORRI}/fileuploadnew`,
  fileService: `${API.FILE}/fileupload`,
  Blobfileupload2: {
    Get: UPLOAD_BASE_URL,
  },
  Blobfileupload: {
    Get: `https://blobfileupload.azurewebsites.net/api/blobfile`,
  },
  profileFileUpload: `${API.RPT}/profile_file_upload`,
  planning: `${API.PLANNING}/`,
  Email: `https://tpmpapi.azurewebsites.net/api/trigger_email`,
  procureEmail: `https://internalapisnew.azurewebsites.net/api/${PROCURE_EMAIL}`,
  emailRating: `${EMAIL_BASE_URL}/api/rating_by_email`,
  DhandhaNow: {
    searchCompanies: `${API.LORRI}/search?search_field=companies`,
    user_details: `${API.USER}/user_transporter`,
    EOI: `https://internalapisnew.azurewebsites.net/api/EOI_history`,
  },
  excelTemplate: `${API.USER}/transporter-excel/template`,
  excelPrefilled: `${API.USER}/transporter-excel/prefilled`,
  excelUpload: `${API.USER}/transporter-excel/upload`,
  LorriLogoLogin:
    "https://rnrdeploynew.blob.core.windows.net/staticimages/LoRRI_screen_zero-min.png",
  appnamemixpanel: APP_NAME,
};